export default "__VITE_ASSET__9df70881__"